import { render, staticRenderFns } from "./ModalEditOneSeedTreatment.vue?vue&type=template&id=1bd4eece&scoped=true"
import script from "./ModalEditOneSeedTreatment.vue?vue&type=script&lang=js"
export * from "./ModalEditOneSeedTreatment.vue?vue&type=script&lang=js"
import style0 from "./ModalEditOneSeedTreatment.vue?vue&type=style&index=0&id=1bd4eece&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4eece",
  null
  
)

export default component.exports